export default __webpack_public_path__ + "static/media/pinball.c85db693.png";